import { useContext } from 'react';
import SegmentationFiltersInstanceContext from '../../state/SegmentationFiltersInstanceContext';
import get from 'transmute/get';
import ViewerTopLevelLogicGroupItem from './ViewerTopLevelLogicGroupItem';
import BannersContainer from 'customer-data-filters-ui/components/common/BannersContainer';
import ViewerAddGroup from './ViewerAddGroup';
import { isLogicGroupHasAtLeastOneCondition } from '../../filterQueryFormat/logic/LogicGroup';
import { View } from 'foundations-components/components/View';
import { ScrollContainer as FoundationsScrollContainer } from 'foundations-components/transitional/components/ScrollContainer';
import { View as FoundationsView } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ViewerContentStandard = ({
  inputUse,
  header,
  showLogicGroupOperatorToggles = false
}) => {
  const {
    internalDraftValue,
    props: {
      isAndGroup,
      matchStatuses,
      bannerComponents,
      footer,
      uiMessages: {
        viewerEmptyFiltersForSkipEmptyFiltersState
      },
      useOnePanel
    }
  } = useContext(SegmentationFiltersInstanceContext);
  const logicOperator = internalDraftValue === null || internalDraftValue === void 0 ? void 0 : internalDraftValue.logicGroupName;

  // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
  const noFiltersSet = internalDraftValue.conditions.size === 0;
  const isSingleEmptyFilterGroup =
  // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
  internalDraftValue.conditions.size === 1 &&
  // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
  !isLogicGroupHasAtLeastOneCondition(internalDraftValue.conditions.get('0'));
  const customEditEmptyState = viewerEmptyFiltersForSkipEmptyFiltersState ? /*#__PURE__*/_jsx(View, {
    textAlign: "center",
    marginBlockStart: "1100",
    children: viewerEmptyFiltersForSkipEmptyFiltersState
  }) : null;
  const renderCustomEditEmptyState = isSingleEmptyFilterGroup && customEditEmptyState;
  const renderGroups = !noFiltersSet && !renderCustomEditEmptyState;
  const renderAddGroup = !renderCustomEditEmptyState;
  return /*#__PURE__*/_jsxs(FoundationsScrollContainer, {
    id: "cdf-viewer-scrolling-container",
    gradientColor: useOnePanel ? 'fill-surface-default' : 'fill-tertiary-default',
    children: [header, /*#__PURE__*/_jsxs(FoundationsView, {
      "data-selenium-test": "fr-viewer-panel",
      paddingBlockStart: "0",
      paddingInline: "400",
      paddingBlockEnd: "400",
      as: "div",
      children: [/*#__PURE__*/_jsx(BannersContainer, {
        children: bannerComponents
      }), renderCustomEditEmptyState ? customEditEmptyState : null, renderGroups ?
      // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
      internalDraftValue.conditions.toArray().map((group, index) => {
        if (isAndGroup && index !== 0) {
          return null;
        }
        return /*#__PURE__*/_jsx(ViewerTopLevelLogicGroupItem, {
          inputUse: inputUse,
          logicGroup: group,
          logicGroupIndex: index
          // @ts-expect-error logicOperator might be undefined
          ,
          logicOperator: logicOperator
          // @ts-expect-error ts-migrate(2345) FIXME
          ,
          matchStatus: get(index, matchStatuses),
          showLogicGroupOperatorToggles: showLogicGroupOperatorToggles
        }, `${index}-${group.name}`);
      }) : null, renderAddGroup && /*#__PURE__*/_jsx(ViewerAddGroup, {
        showLogicGroupOperatorToggle: showLogicGroupOperatorToggles && (internalDraftValue === null || internalDraftValue === void 0 ? void 0 : internalDraftValue.conditions.size) === 1,
        showLogicGroupOperatorToggles: showLogicGroupOperatorToggles
      }), /*#__PURE__*/_jsx(View, {
        paddingBlockStart: "400",
        children: footer
      })]
    })]
  });
};
export default ViewerContentStandard;